import Template from "./template";

export default {
  path: 'appointments-confirmation/:id',
  element: <Template />,
  loader: async ({ params }) => {
    return {};
  },
};
